export const SUGGESTED_FAQ_REJECT_REASON = 'Rejected by admin';
